import styled, { css } from 'styled-components';

export const GridContainer = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: ${theme.spacing.base};
      @media screen and (min-width: ${({ theme }) => theme.breakpoint.sm}) {
        margin: ${theme.spacing.base} 0;
        gap: ${theme.spacing.md};
        grid-template-columns: repeat(2, 1fr);
      }

      @media screen and (min-width: ${({ theme }) => theme.breakpoint.md}) {
        gap: ${theme.spacing.md};
        grid-template-columns: repeat(3, 1fr);
      }

      @media screen and (min-width: ${({ theme }) => theme.breakpoint.lg}) {
        gap: ${theme.spacing.md};
        grid-template-columns: repeat(4, 1fr);
      }
    `;
  }};
`;
